import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { EUR } from "../../../Currency/Currencies/EUR";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import {
    Card,
    TableCell,
    TableRow
} from '@material-ui/core';
import { FinancialStatementInterface } from "Casadesk/Entity/Entities/FinancialStatement/FinancialStatementInterface";
import Memo from "../../Partials/Memo/Memo";
import * as ReactTooltip from 'react-tooltip'
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import CircularProgress from '@material-ui/core/CircularProgress';
import CasedeskUrl from "../../../Url/Url";
import TextField from "../../Partials/Material/TextField";

class Statements extends Component {
    protected paginatorPath: string = `Finance_Statements_${this.props.app.financeOwnerStatementsFilterSearchState}`;
    protected searchTimer;
    protected textFieldRef;

    public state = {
        currentStatement: null,
        statements: [],
        statementsCount: 0,
        isSaving: false,
        anchorEl: null,
        isFetching: true,
        nextPath: "",
        memoPopupOpen: false,
        statementToAddNote: null,
        filterValue: "",
        filter: "all",
        searchInProgress: false,
        languageForPdf: this.props.app?.settings?.agency?.defaultLocale?.iso === "en-US" ? 1 : 2,
    };

    constructor(public props) {
        super(props);

        this.textFieldRef = React.createRef();
    }

    public componentWillMount() {
        const searchFilter = this.props.app.financeOwnerStatementsFilterSearchState;

        this.setState({
            ...this.state,
            filterValue: searchFilter
        }, () => {
            this.fetchFirstAllStatements(() => {
                window.scrollTo({
                    top: this.props.app?.financeStatementsListPosition
                });
            });

            this.fetchFirstAllStatements();
        })
    }

    public componentWillUnmount() {
        clearTimeout(this.searchTimer);

        this.props.dispatch({
            type: Constants.FINANCE_OWNER_STATEMENTS_FILTER_SEARCH_UPDATE_STATE,
            payload: {
                filter: this.state.filterValue
            }
        });
    }

    public componentWillReceiveProps(nextProps) {
        if (!this.props?.financialStatements?.requestsOutdated && nextProps?.financialStatements?.requestsOutdated) {
            this.fetchFirstAllStatements();
        }
    }

    public fetchFirstAllStatements = (callback?) => {
        const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
            this.props.app.paginator[this.paginatorPath] : this.props.app.defaultPaginationAmount;

        const payload: any = {
            // sortBy: "+firstDate",
            offset: 0,
            limit: paginationAmount,
            filterValue: this.state.filterValue,
            removed: 0,
            afterInvoiceNumberStartDate: true
        };

        this.props.dispatch({
            type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
            payload: {
                ...payload
            },
            onSuccess: (data) => {
                this.setState({
                    searchInProgress: false,
                    statements: data.financialStatements,
                    statementsCount: data.count,
                    isFetching: false
                }, () => {
                    if (typeof callback === "function") {
                        callback();
                    }
                });
            },
            onError: () => {
                clearTimeout(this.searchTimer);

                this.setState({
                    searchInProgress: false,
                    isFetching: false
                });
            }
        });
    }

    public fetchFilterAllStatements = () => {
        this.props.dispatch({
            type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
            payload: {
                // sortBy: "+firstDate",
                filterValue: this.state.filterValue,
                removed: 0,
                afterInvoiceNumberStartDate: true
            },
            onSuccess: (data) => {
                this.setState({
                    statements: data.financialStatements,
                    statementsCount: data.count,
                    isFetching: false
                });
            }
        });
    }

    public clearFilterAllStatements = () => {
        this.props.dispatch({
            type: Constants.FINANCE_OWNER_STATEMENTS_FILTER_SEARCH_UPDATE_STATE,
            payload: {
                filter: ""
            }
        });

        this.setState({
            filterValue: ""
        }, this.fetchFilterAllStatements);

        this.textFieldRef.current.focus();
    }

    protected onEnter = (event): any => {
        if (event.key === "Enter") {
            this.paginatorPath = !!this.state.filterValue ?
                `Finance_Statements_${this.state.filterValue}` :
                `Finance_Statements_`;

            this.props.dispatch({
                type: Constants.FINANCE_OWNER_STATEMENTS_FILTER_SEARCH_UPDATE_STATE,
                payload: {
                    filter: this.state.filterValue
                }
            });

            if (this.state.filter === "all") {
                this.fetchFirstAllStatements();
            }
        }
    }

    public setFilterValue = (event): any => {
        clearTimeout(this.searchTimer);

        this.setState({
            filterValue: event.target.value
        }, () => {
            if (this.state.filterValue === "") {
                if (this.state.filter === "all") {
                    this.clearFilterAllStatements();
                }
            }

            this.searchTimer = setTimeout(() => {
                this.setState({
                    searchInProgress: true
                }, () => {
                    this.paginatorPath = `Finance_Statements_${this.state.filterValue}`;

                    this.props.dispatch({
                        type: Constants.FINANCE_OWNER_STATEMENTS_FILTER_SEARCH_UPDATE_STATE,
                        payload: {
                            filter: this.state.filterValue
                        }
                    });

                    if (this.state.filter === "all") {
                        this.fetchFirstAllStatements();
                    }
                });
            }, this.props.app?.listSearchTimeout);
        });
    }

    public fetchStatements = () => {
        if (this.state.filter === "all") {
            const payload: any = {
                // sortBy: "+firstDate",
                offset: !!this.state.statements ? this.state.statements.length : 0,
                limit: this.props.app.defaultPaginationAmount,
                filterValue: this.state.filterValue,
                removed: 0,
                afterInvoiceNumberStartDate: true
            };

            this.props.dispatch({
                type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
                payload: {
                    ...payload
                },
                onSuccess: (data) => {
                    const statementsArr = !!this.state.statements ?
                        [...this.state.statements, ...data.financialStatements] : [...data.financialStatements];

                    this.setState({
                        statements: statementsArr,
                        statementsCount: data.count,
                        isFetching: false
                    });
                }
            });
        }
    }

    public getAmountsOfFilteredStatements = (filter: string): number => {
        switch (filter) {
            case "all":
                return this.state.statementsCount;
            default:
                return;
        }
    }

    public getFilteredStatements = (filter: string) => {
        switch (filter) {
            case "all":
                return this.state.statements;
            default:
                return;
        }
    }

    protected openMenu = (event: any, statement): void => {
        this.setState({
            currentStatement: statement,
            anchorEl: event.currentTarget
        });
    }

    protected closeMenu = (): void => {
        this.setState({
            anchorEl: null
        });
    }

    public download = (chargeId: number): void => {
        this.saving(() => {
            this.props.dispatch({
                type: Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_START,
                payload: {
                    chargeId: chargeId,
                    language: this.state.languageForPdf
                },
                onSuccess: url => {
                    window.open(CasedeskUrl.getAttachment(url), "_blank");

                    this.setState({
                        isSaving: false
                    })
                },
                onError: () => {
                    this.setState({
                        isSaving: false
                    })
                }
            });
        })
    }

    public saveScrollPosition = () => {
        var top = window.pageYOffset || document.documentElement.scrollTop;

        this.props.dispatch({
            type: Constants.FINANCE_STATEMENTS_LIST_POSITION_SAVE,
            payload: {
                position: top
            }
        });
    }

    public getStatements = () => {

        return this.getFilteredStatements(this.state.filter)
            .map((statement, index: number) => {
                const owner = statement?.owner;

                // TODO: rewrite this part
                const properties = owner.properties;

                let propertyStreetDetailsFirst;
                let propertyStreetDetailsSecond;
                let propertyStreetDetailsThird;

                if (properties[0]) {
                    propertyStreetDetailsFirst = properties[0]?.address?.route ? `${properties[0].address.route}` : properties[0]?.address?.formattedAddress;
                }
                if (properties[1]) {
                    propertyStreetDetailsSecond = properties[1]?.address?.route ? `${properties[1].address.route}` : properties[1]?.address?.formattedAddress;
                }
                if (properties[2]) {
                    propertyStreetDetailsThird = properties[2]?.address?.route ? `${properties[2].address.route}` : properties[2]?.address?.formattedAddress;
                }

                return (
                    <TableRow
                        hover
                        key={index}
                        className={`clickable-entity`}
                        onClick={() => {
                            this.saveScrollPosition();
                            this.redirect(`/app/owner-statement/update/${statement.id}`)
                        }}
                    >
                        <TableCell style={{ width: "24px", paddingLeft: "24px", paddingRight: "0px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                                <div
                                    className="icon icon-ic-finances"
                                    style={{
                                        color: "rgb(0, 188, 212)"
                                    }}
                                >
                                </div>
                            </div>
                        </TableCell>
                        <TableCell style={{ width: "14%" }}>{this.formatter.monthYearFormatDate(statement.firstDate)}</TableCell>
                        <TableCell style={{ width: "27%" }}>{owner?.displayName}</TableCell>
                        <TableCell style={{ width: "27%" }}>{`${propertyStreetDetailsFirst ? `${propertyStreetDetailsFirst}` : ""} ${propertyStreetDetailsSecond ? `, ${propertyStreetDetailsSecond}` : ""} ${propertyStreetDetailsThird ? `, ${propertyStreetDetailsThird}` : ""}`}</TableCell>
                        <TableCell style={{ width: "14%" }}>
                            {
                                <div
                                    style={{
                                        display: "flex", justifyContent: "flex-start", flexWrap: "wrap"
                                    }}
                                >
                                    {
                                        !statement?.isSent && (
                                            <div style={{ padding: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <div className="list-label creation-type-label" style={{ minWidth: "85px" }}>
                                                    {this.trans("label-not-sent")}
                                                </div>
                                            </div>

                                        )
                                    }
                                    {
                                        statement?.isSent && (
                                            <div style={{ padding: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <div className="list-label creation-type-label green" style={{ minWidth: "85px" }}>
                                                    {this.trans("status-sent")}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            }
                        </TableCell>
                        <TableCell style={{ width: "3%" }}>
                            <div
                                className="icon icon-ic-pdf aligned"
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.download(statement?.actualPayoutChargeId)
                                }}
                            ><span className="path1 icon-ic-pdf"></span><span className="path2 icon-ic-pdf"></span><span className="path3 icon-ic-pdf"></span></div>
                        </TableCell>
                        <TableCell style={{ width: "3%" }}>
                            {this.renderStatementMemoIcon(statement)}
                        </TableCell>
                        <TableCell style={{ width: "12%" }}>
                            {this.formatter.formatNumber(statement?.payoutSection ? statement?.payoutSection?.result : statement?.result, new EUR())}
                        </TableCell>
                    </TableRow>
                );
            });
    }

    public getTipText = (tip: string) => {
        const tipLength = 30;

        if (tip.length > tipLength) {
            return `${tip.slice(0, tipLength)}...`;
        }

        return tip;
    }

    public renderStatementMemoIcon = (statement: FinancialStatementInterface) => {
        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span>
                    {/* <span data-tip={this.getTipText(statement?.note)}> */}
                    <div className={`icon ${statement?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
                        onClick={e => {
                            e.stopPropagation();
                            this.openMemoPopup(statement);
                        }}
                    >
                    </div>
                    {/* </span> */}
                    <ReactTooltip place="bottom" />
                </span>
            </div>
        );
    }

    public openMemoPopup = (statement: FinancialStatementInterface) => {
        this.setState({
            statementToAddNote: statement,
            memoPopupOpen: true,
            anchorEl: null
        });
    }

    public render() {
        return (
            <div className="state-app">
                <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
                    <div className="component-header no-paddings">
                        <h1>{this.trans("title-finance")}</h1>
                        <TabsComponent
                            activeTab={2}
                            {...this.props}
                        />
                    </div>

                    <div className="component-wrapper no-margin-top">
                        <Card className="card no-padding">
                            <div className="label-container"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "baseline"
                                }}
                            >
                                <h3 className="card-title" style={{ flexDirection: "column", display: "flex" }}>
                                    {this.trans("title-statements")}
                                </h3>
                            </div>

                            <div>
                                <div
                                    className="list-filters-wrapper"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="table-filterer">
                                        <TextField
                                            autoComplete="off"
                                            type="text"
                                            style={{ color: "rgb(0, 188, 212)" }}
                                            label={this.trans("label-search")}
                                            value={this.state.filterValue}
                                            onChange={this.setFilterValue}
                                            variant="standard"
                                            error={false}
                                            inputRef={this.textFieldRef}
                                        />
                                        {this.state.filterValue !== "" &&
                                            <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.clearFilterAllStatements}></div>
                                        }
                                        {
                                            this.state.searchInProgress &&
                                            <div className="search-loader">
                                                <CircularProgress size={20} />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <TableComponent
                                    {...this.props}
                                    paginator={{
                                        name: this.paginatorPath,
                                        path: this.props.app.paginator
                                    }}
                                    className="listing-table statements-listing-table with-first-border not-3-dot"
                                    headers={[
                                        "", this.trans("label-period"), this.trans("owner"), this.trans("title-properties"), "", "", "", this.trans("result")
                                    ]}
                                    rows={this.getStatements()}
                                    rowsLength={this.getAmountsOfFilteredStatements(this.state.filter)}
                                    subtitle={this.trans("title-no-statements-to-list")}
                                    fetch={this.fetchStatements}
                                    isFetching={this.state.isFetching}
                                    filtering={this.state.filterValue.length > 0}
                                />
                            </div>
                        </Card>
                    </div>
                </div>

                <PromptDialog
                    {...this.props}
                    title={this.trans("memo")}
                    content={
                        <div>
                            <Memo
                                {...this.props}
                                relations={{ financialStatementId: this.state.statementToAddNote?.id }}
                                fetchEntities={() => {
                                    this.props.dispatch({
                                        type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS
                                    });

                                    this.fetchFirstAllStatements();
                                }}
                            />
                        </div>
                    }
                    prioritizeClosing={true}
                    openLeavePrompt={this.state.memoPopupOpen}
                    onlyPositiveButton={true}
                    positiveButtonLabel={this.trans("button-close")}
                    onSave={() => this.setState({ memoPopupOpen: false })}
                    hideCross={true}
                    subtitle={`${this.formatter.monthYearFormatDate(this.state.statementToAddNote?.firstDate)}, ${this.state.statementToAddNote?.owner?.displayName}`}
                />

                <PageTransition isSaving={this.state.isSaving} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        app: state.app,
        events: state.events,
        units: state.units,
        component: state.statements,
        globalTypes: state.globalTypes,
        financialStatements: state.financialStatements,
    };
};

export default connect(mapStateToProps)(Statements);